/*
 JQuery Scroll In
 Version: 1.0.0
 Author: Yoshikazu Sugata
 License: MIT
 */
;(function($, window, undefined) {

    let $ScrollInFuncs = {
        // プラグイン設定
        plugin_settings: {
            "trigger_class_name": "slide-event",
            "complete_class_name": "complete",
        },

        // デフォルト設定
        default_options: {
            "distance": 50,     // パーセント。100を超える場合は100として扱う
            "interval": 500,    // ミリ秒。処理実行までの待機時間を表す
            "addClass": "",     // complete以外に追加するクラスを設定する
        },

        // 監視対象要素
        watch_list: [],

        // initialize
        init: function(options){
            // 監視対象要素を取得(watch_listに格納)
            $ScrollInFuncs._setWatchElems(options);

            // リロード時の処理として、load時にスクロールイベントを手動で実行
            $ScrollInFuncs._scroll_in();

            // $windowにスクロールイベントを設定
            $ScrollInFuncs._addScrollEvent();
        },

        // クラス名取得
        _getClassName: function(val){
            return "." + val;
        },
        
        // 監視対象要素を監視対象リストに設定する
        _setWatchElems: function(options){
            // jQueryで要素を検索・取得
            let elems = $($ScrollInFuncs._getClassName($ScrollInFuncs.plugin_settings.trigger_class_name)).not($ScrollInFuncs._getClassName($ScrollInFuncs.plugin_settings.complete_class_name));
            let group_op = typeof options === "object" && typeof options.forEach === "undefined" ? options : {};

            // 要素を全件走査
            elems.each(function(){
                let elem = this;
                // 要素に付いているオプション設定を取得
                $elem_op = typeof $(elem).data("option") === "undefined" ? {} : $(elem).data("option");

                // デフォルト設定とマージして、個別の設定とする
                $options = $.extend({}, $ScrollInFuncs.default_options, group_op, $elem_op);

                // watch_listに追加
                $ScrollInFuncs.watch_list.push( {"elem": elem, "options": $options} );
            });
        },
        _addScrollEvent: function(){
            $(window).on("scroll", function(){
                // スクロールイベント
                $ScrollInFuncs._scroll_in();
            });
        },
        // 現在表示しているエリアの下弦位置(px)
        _getScrollBottom: function(){
            let scrolltop = $(window).scrollTop();
            return scrolltop + window.innerHeight;
        },
        _scroll_in: function(){
            // 現在のスクロール位置（下）
            let now_scroll_bottom = $ScrollInFuncs._getScrollBottom();

            $ScrollInFuncs.watch_list.forEach(function(item){
                // 監視対象要素の
                // 処理開始の高さ補足
                let distance = item.options.distance > 100 ? 100 : item.options.distance;
                distance = distance < 0 ? 0 : distance;

                // 要素の表示位置（上からのpx）
                let offset_top = item.elem.offsetTop + ($(item.elem).height() * (distance / 100));

                // 表示エリア内に入ったか確認
                if(now_scroll_bottom > offset_top){
                    // 表示エリアに入った場合は、処理を実施
                    $ScrollInFuncs._set_class(item);
                }
            });
        },
        _set_class: function(item){
            // completeが付いていない要素のみ処理を行う（既にcompleteが付いている要素は再度の処理は行わない）
            if($(item.elem).hasClass($ScrollInFuncs.plugin_settings.complete_class_name) === false){

                setTimeout(function(aa){
                    $(item.elem).addClass($ScrollInFuncs.plugin_settings.complete_class_name);
                    if(item.options.addClass !== ""){
                        $(item.elem).addClass(item.options.addClass);
                    }
                }, item.options.interval);
            }
        },
    };

    // Preventing against multiple instantiations for the same DOM element
    $.fn.scrollIn = function (options) {

        this.each(function(){
            // 設定を行う
            $ScrollInFuncs.init(options);
        });

        // thisを返す
        return this;
    };

})(jQuery, window);